import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import Row from "../../../layout/Row";
import Col from "../../../layout/Col";
import SectionView from "../../../layout/section/SectionView";
import FormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import FormButtonsView from "../../../ui/form/FormButtonsView";
import {none, Option, option} from "ts-option";
import MaterialSelectionComponent from "./MaterialSelectionComponent";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";
import MaterialSearch from "../../../../model/material/MaterialSearch";
import CurrencyHelper from "../../../../helper/CurrencyHelper";
import Toast from "../../../helper/Toast";
import {Dispatch} from "redux";
import {OnFailure, OnSuccessData} from "../../../../store/action/actionHelpers";
import {addMaterialToAssetOnBillOfMaterials,} from "../../../../store/action/billOfMaterials/billOfMaterials";
import {connect} from "react-redux";
import SuggestedAssetPrice from "../../../../model/job/SuggestedAssetPrice";
import {BomItem} from "../../../../model/job/BomItems";

interface IComponentProps {
	/**
	 * On successfully added material callback.
	 */
	onSuccess: (suggestedAssetSellPrice: SuggestedAssetPrice) => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
	/**
	 * Bill of materials id
	 */
	bomDetailsId: string;
	/**
	 * Selected asset
	 */
	selectedAsset: BomItem;
	/**
	 * Merchant id
	 */
	bomMerchantId: string;
	/**
	 * Job id
	 */
	jobId: string;
}

interface DispatchProps {
	/**
	 */
	addMaterialToAssetOnBillOfMaterials: (bomId: string, assetId: string, materialId: string, jobId: string,
		onSuccess: OnSuccessData<SuggestedAssetPrice>, onFailure: OnFailure) => void
}

interface IState {
	/**
	 * Material selected to add.
	 */
	selectedMaterial: Option<MaterialSearch>;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

type Props = IComponentProps & DispatchProps;

class AddMaterialModal extends React.Component<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {
			selectedMaterial: none,
			isSubmitting: false
		};
		this.renderSelectedMaterial = this.renderSelectedMaterial.bind(this);
		this.addMaterial = this.addMaterial.bind(this);
		this.getHeader = this.getHeader.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onCancel} title={this.getHeader()}>
				<SectionView>
					<div style={{marginTop: '25px', height: '300px'}}>
						<Row>
							<Col>
								<FormGroup label={'Material'}>
									{this.state.selectedMaterial.map(this.renderSelectedMaterial).getOrElse(() =>
										<MaterialSelectionComponent
											bomMerchantId={this.props.bomMerchantId}
											onSelect={(material) => this.setState({selectedMaterial: option(material)})}
											placeholder={'Search by description, manufacturer code, merchant code'}/>
									)}
								</FormGroup>
							</Col>
						</Row>
					</div>
				</SectionView>
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.onCancel}
									label={"Cancel"}
									disabled={this.state.isSubmitting}/>
					<ButtonPrimary onClick={this.addMaterial}
								   label={"Add"}
								   disabled={this.state.isSubmitting || this.state.selectedMaterial.isEmpty}
								   isLoading={this.state.isSubmitting}/>
				</FormButtonsView>
			</Modal>
		);
	}

	getHeader() {
		return (
			<div>Add material to "<strong>{this.props.selectedAsset.name}</strong>"</div>
		);
	}

	renderSelectedMaterial(material: MaterialSearch) {
		return (
			<div className="bom-selection selected">
				<div className="c-selection-bom-modal_select-option-component">
					<div className="c-selection-bom-modal_select-option-component_labels">
						<div>
							<span className="c-selection-bom-modal_select-option-component_labels_column">
								<b className="c-selection-bom-modal_select-option-component_labels_blue-color">
									{material.description}</b>
							</span>
						</div>
						<div className="c-selection-bom-modal_select-option-component_labels_blue-color fit-content">
							<span><b>{material.price.map(CurrencyHelper.toCurrency).orNull}</b></span>
							<ButtonTertiary label={'X'} onClick={() => this.setState({selectedMaterial: none})}/>
						</div>
					</div>
				</div>
			</div>
		)
	}

	addMaterial() {
		if (!this.state.selectedMaterial.isEmpty) {
			this.setState({isSubmitting: true}, () => {
				this.props.addMaterialToAssetOnBillOfMaterials(this.props.bomDetailsId,
					this.props.selectedAsset.id, this.state.selectedMaterial.get.id, this.props.jobId,
					(price) => {
						this.setState({isSubmitting: false});
						this.props.onSuccess(price);
						Toast.success('Material added', 'Add material');
					},
					(error) => {
						this.setState({isSubmitting: false});
						notifyBugsnagAndShowToast(error, 'Add material to an asset on order');
					});
			});
		}
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		addMaterialToAssetOnBillOfMaterials: (bomId: string, assetId: string, materialId: string, jobId: string,
			onSuccess: OnSuccessData<SuggestedAssetPrice>, onFailure: OnFailure) => dispatch(
			addMaterialToAssetOnBillOfMaterials(bomId, assetId, materialId, jobId, onSuccess, onFailure)
		)
	}
}

export default connect(null, mapDispatchToProps)(AddMaterialModal);